import * as React from 'react'
import { ReactElement } from 'react'
import Fieldset from '../../Form/Fieldset'
import PostalCodeField from '../../Form/PostalCodeField'
import { useFormikContext } from 'formik'
import FormikTextField from '../../Formik/TextField/FormikTextField'
import { Stack, StackItem } from '@fluentui/react'
import useViewport, { Viewport } from '../../../hooks/useViewport'
import { useTranslation } from 'react-i18next'
import CountryCombobox, { CountryComboboxProps } from '../../Combobox/i18n/CountryCombobox'
import FormikComboboxField from '../../Formik/FormikComboboxField'

type Props = {
    legend: string
    prefix: string
    open?: boolean
}

export default function LegacyAddressField(props: Props): ReactElement {
    const { t: translate } = useTranslation()

    const { values, errors, handleChange, handleBlur } = useFormikContext()
    const context = useFormikContext()
    const { isViewport, getGap } = useViewport()

    return (
        <Fieldset legend={props.legend} canToggle open={props.open ?? false}>
            <Stack horizontal tokens={{ childrenGap: getGap() }}>
                <StackItem grow>
                    <FormikTextField context={context} label={translate('party.edit.address.street')} fieldName={props.prefix + 'Street'} />
                </StackItem>
                <StackItem shrink styles={{ root: { maxWidth: 80 } }}>
                    <FormikTextField context={context} label={translate('party.edit.address.number')} fieldName={props.prefix + 'Number'} />
                </StackItem>
            </Stack>
            <Stack horizontal={isViewport('>=', Viewport.Large)} tokens={{ childrenGap: getGap() }}>
                <Stack grow horizontal tokens={{ childrenGap: getGap() }}>
                    <StackItem grow styles={{ root: { maxWidth: 100 } }}>
                        <PostalCodeField
                            label={translate('party.edit.address.postalcode')}
                            value={values[props.prefix + 'PostalCode'] || ''}
                            errorMessage={errors?.[props.prefix + 'PostalCode']}
                            onChange={handleChange(props.prefix + 'PostalCode')}
                            onBlur={handleBlur(props.prefix + 'PostalCode')}
                            country={values[props.prefix + 'Country']}
                        />
                    </StackItem>
                    <StackItem grow>
                        <FormikTextField context={context} label={translate('party.edit.address.locality')} fieldName={props.prefix + 'Locality'} />
                    </StackItem>
                    <StackItem grow>
                        <FormikTextField
                            context={context}
                            label={translate('party.edit.address.municipality')}
                            fieldName={props.prefix + 'Municipality'}
                        />
                    </StackItem>
                </Stack>
            </Stack>
            <Stack horizontal tokens={{ childrenGap: getGap() }}>
                <StackItem grow styles={{ root: { maxWidth: isViewport('>=', Viewport.Large) ? 240 : undefined } }}>
                    <FormikComboboxField<any, CountryComboboxProps>
                        labelKey="party.edit.address.country"
                        fieldName={props.prefix + 'Country'}
                        component={CountryCombobox}
                    />
                </StackItem>
            </Stack>
        </Fieldset>
    )
}
